export enum ErrorMessages {
	GenericError = 'Please check your internet connection and try again.',
	NoNewsroomSectionResults = 'There are no results in this newsroom section at the moment. It could also be that there are no results that meet your search criteria... Please try again later.',
	NewsItemsNotFound = 'There are no news items available at the moment. Please try again later.',
	BlogItemsNotFound = 'There are no blog items available at the moment. Please try again later.',
	FlightsNoResults = 'There are no flights available for your search. Please change your search or try again later.',
	JobsNotFound = 'There are no jobs available at the moment. Please try again later.',
	JobsNoSearchResults = 'There are no jobs available for your search. Please change your search.',
	NoResults = 'There are no results for your search. Please change your search.',
}
